import { InquiryComplaintData, SUCommonRequestData, TaskService } from '@pulseops/common'
import React from 'react'
export type TaskDashboardContextData = {
  subServiceTypeList: InquiryComplaintData.IACType[]
  subTransactionTypeList: Array<InquiryComplaintData.IACSubtypes>
  commonRequests: SUCommonRequestData.CommonRequest[]
  PSSLAStandardArr: TaskService.PSSLAStandard []
  CSSLAStandardArr: TaskService.CustomerServiceStandardSLA []
}
const defaultValues: TaskDashboardContextData = {
  subServiceTypeList: [],
  subTransactionTypeList: [],
  commonRequests: [],
  PSSLAStandardArr: [],
  CSSLAStandardArr: []
}
export const TaskDashboardContext = React.createContext<TaskDashboardContextData>(defaultValues)